function LoaderSpin({ show = true, width = 5, height = 5, wrapperClass = 'bg-white', spinClass = 'border-t-primary' }) {
  return (
    show && (
      <div className={`flex items-center justify-center absolute inset-tl size-full z-20 ${wrapperClass}`}>
        <div className={`relative w-${width} h-${height}`}>
          <div className={`absolute inset-tl size-full animate-spinner rounded-full border-2 border-gray-100 ${spinClass}`}></div>
        </div>
      </div>
    )
  )
}

export default LoaderSpin
